import { Box, Stack, Typography, useTheme } from '@mui/material';
import { CloudControllerReader } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import SectionPaper from 'v2/components/SectionPaper/SectionPaper';
import StatusChip from 'v2/components/StatusChip/StatusChip';
import getFirmwareUpdateChip from './getFirmwareUpdateChip';

interface Props {
  readers: CloudControllerReader[];
}

const ReadersCard: React.FC<Props> = ({ readers }) => {
  const { translation } = useTranslation();
  const theme = useTheme();

  return (
    <SectionPaper>
      <Stack spacing={2}>
        <Typography variant="h5">{translation.readers}</Typography>
        <Stack spacing={0.5}>
          {readers.map((reader) => (
            <Stack
              key={reader.serialNumber}
              id={`reader-${reader.serialNumber}-row`}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              columnGap={1}
              sx={{ backgroundColor: theme.custom.background.level2, borderRadius: 1, py: 1, px: 2 }}
            >
              <Typography variant="body1" noWrap minWidth={0}>
                {reader.serialNumber}
              </Typography>
              {reader.firmwareUpdate && (
                <Box flexShrink={0}>
                  <StatusChip chipOnly {...getFirmwareUpdateChip(reader.firmwareUpdate, translation)} />
                </Box>
              )}
            </Stack>
          ))}
          {readers.length === 0 && (
            <Typography variant="body2" color="textSecondary">
              {translation.no_readers}
            </Typography>
          )}
        </Stack>
      </Stack>
    </SectionPaper>
  );
};

export default ReadersCard;
